<template>
  <div id="app">
    <router-view/>
    <div class="bg"></div>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  },
  created() {

  },
  methods: {

  }
}

</script>



<style>
.van-dropdown-item {
  z-index: 10000!important;
}

.flex-center {
  text-align: center;
  display: flex;
  justify-content: center!important;
}

#app .bg {
  background-image: url('@/public/img/eevee_bg.jpg');
  opacity: 0.15;
  position: fixed;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  z-index: -2;
  top: 0;
  left: 0;
}



</style>
